import React from 'react';
import { Route, Routes } from 'react-router-dom';
import UploadDocument from './UpdateDocument.tsx';
import ViewDocument from './ViewDocument.tsx';
import OrganisationDashboard from '../Home/OrganisationDashboard.tsx';
const ClientOnboarding = () => {
  return (
    <Routes>
      <Route exact path={`update-document/*`} element={<UploadDocument />} />
      <Route exact path={`view-document/*`} element={<ViewDocument />} />
      
  
    </Routes>
  );
}

export default ClientOnboarding;
